import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  Heading,
  Button,
  ButtonIcon,
  Separator
} from '@brandwatch/axiom-components';

import { getComponentById, getSlideByComponentId } from '../../selectors';

class InteractiveComponentHeader extends PureComponent {
  render() {
    const { component, slide, onRequestClose } = this.props;
    return (
      <React.Fragment>
        <div className="InteractiveComponent__Header">
          <div>
            <div className="InteractiveComponent__SlideTitle">
              <div className="InteractiveComponent__Close--rotated">
                <Button
                  size="small"
                  style="quaternary"
                  onClick={onRequestClose}
                >
                  <ButtonIcon
                    name="arrow-down"
                    size="var(--spacing-grid-size--x5)"
                  />
                </Button>
              </div>

              <div className="InteractiveComponent__SlideTitle--centered">
                <Heading textSize="large" textColor="subtle" space="x0">
                  {slide.name}
                </Heading>
              </div>
            </div>

            <div className="InteractiveComponent__ComponentTitle">
              <Heading textSize="headtitle" textCase="upper" space="x0">
                {component.name}
              </Heading>
            </div>
          </div>
          <div className="InteractiveComponent__Separator">
            <Separator />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

InteractiveComponentHeader.propTypes = {
  component: PropTypes.object.isRequired,
  slide: PropTypes.object.isRequired,
  onRequestClose: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  component: getComponentById(state, props),
  slide: getSlideByComponentId(state, props)
});

export default connect(mapStateToProps)(InteractiveComponentHeader);
